var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.theme)?_c('PgConfigProvider',{attrs:{"themeColor":_vm.themeColor,"colorHook":_vm.colorHook}},[_c('div',{staticClass:"app-main",attrs:{"id":"main"}},[_c('router-view')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }